module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }